import {
    TmcOrderEquityLegViewModel,
    TmcOrderLegViewModel,
    TmcOrderOptionLegViewModel
} from "../../models/OrderViewModel";
import {TmcLeg, TmcOrderRecord} from "../../models/OrderRecord";
import {Exchange} from "../../../instruments/exchange/Exchange";
import {OptionRecord} from "../../../options/contracts/models/OptionChainRecord";
import {OptionContractsCache} from "../../../options/contracts/cache/OptionContractsCache";
import {PortfolioType} from "../../../portfolio/models/Portfolio";
import {QuoteHashMap} from "../../../quote/util/QuoteStoreUtil";
import {QuoteParameters} from "../../../quote/models/QuoteParameters";
import {QuoteViewModel} from "../../../quote/models/QuoteViewModel";

export class TmcLegViewModelFactory {

    public static readonly id = "tmcLegViewModelFactory";

    /** @ngInject */
    public constructor(private readonly optionContractsCache: OptionContractsCache) {
    }

    public async build(order: TmcOrderRecord,
                       quotes: QuoteHashMap<QuoteViewModel>,
                       portfolioType: PortfolioType): Promise<ReadonlyArray<TmcOrderLegViewModel>> {
        const legs = order.legs.map((l) => this.buildLeg(l, quotes, portfolioType));
        return Promise.all(legs);
    }

    private async buildLeg(leg: TmcLeg,
                           quotes: QuoteHashMap<QuoteViewModel>,
                           portfolioType: PortfolioType): Promise<TmcOrderLegViewModel> {
        const key = this.quoteKey(leg, portfolioType);
        const quote = quotes.get(key);
        if (leg.exchange === Exchange.AOM) {
            let contract: OptionRecord | null = null;
            try {
                contract = await this.optionContractsCache.find(leg);
            } catch (e) {

            }
            return TmcOrderOptionLegViewModel.of(leg, contract, quote);
        } else {
            return TmcOrderEquityLegViewModel.of(leg, quote);
        }
    }

    private quoteKey(leg: TmcLeg, portfolioType: PortfolioType): QuoteParameters {
        return {
            code: leg.code,
            exchange: leg.exchange,
            portfolioType
        };
    }
}
